// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../fonts and images/solarpanel.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* #####  Code for Login, LoginComponent, Signup, ForgotPassword, Otpcomponent  ##### */

.login-page {
  height: 100%;
  width: 100%;
  background-image: linear-gradient(
      to right bottom,
      #122b4f,
      rgba(202, 190, 240, 0.082)
    ),
    url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}
.login-page>:first-child{
  /* width: 100%; */
  position: fixed;
  z-index: 12;
  padding: 1vmin 1.5vmin; 
}

.login {
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
  gap: 3vmax;
}

.login .text-heading {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  width: 30%;
}

.login .login-container {
  transition:width .3s ease-in-out;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  width: 30%;
} 

.login-box {
  padding:  2vmax;
  background-color: rgba(6, 127, 127, 0.968);
  border-radius: 10px;
  -webkit-backdrop-filter: blur(10px);
          backdrop-filter: blur(10px);
  --webkit-backdrop-filter: blur(10px);
  box-shadow: 50px 50px 17px rgba(0, 0, 0, 0.6);
  z-index: 10;
  border-width: 5px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1.5vmax;
}

.login-box>:last-child{
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.5vmax;
}

.inputs {
  width: 100%;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
}
.inputs>input{
  height: 3rem;
  width: 100%;
}

.buttons {
  text-align: center;
}

.login .text-heading .container{
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 0.5vmax;
}

.login .text1 {
  font-size: 5vmax;
  color: #ed7d31;
  font-family: "Lucida Sans", "Lucida Sans Regular", "Lucida Grande",
    "Lucida Sans Unicode", Geneva, Verdana, sans-serif;
  z-index: 10;
  font-weight: bolder;
}

.login .text3 {
  font-size: 5vmax;
  color: rgb(231, 229, 221);
  font-family: "Lucida Sans", "Lucida Sans Regular", "Lucida Grande",
    "Lucida Sans Unicode", Geneva, Verdana, sans-serif;
  z-index: 10;
  font-weight: bolder;
}

.login .text2 {
  font-size: 1.8vmax;
  color: #ed7d31;
  font-family: "Lucida Sans", "Lucida Sans Regular", "Lucida Grande",
    "Lucida Sans Unicode", Geneva, Verdana, sans-serif;
  z-index: 1;
  display: block;
}

.forgot_password{
  font-size:medium;
  letter-spacing: 0.1rem;
  font-weight: 600;
  color: rgba(5, 45, 45, 0.968);
  color: white;
  cursor: pointer;
  text-align: center;

}
.forgot_password:hover{
  color: rgb(237, 241, 245);
  
} 

.inputs>input{
  outline: none;
}



@media screen and (max-width:950px) {
  .login-page{
    height:110%;
  }
  .login{
    padding-top: 4vmax;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 6vmax;

  }
  .login .text-heading {
    width: 70%;
    height: auto;

  }
  .login .login-container{
    height: auto;
  }
  .login-box{
    width: 40vmax;
  }
  .login .text-heading .container{
    justify-content: center;
    align-items: center;
  }
  .login .login-container {
    width: 50%;
  }
  .login .text1,.login .text3{
    text-align: center;
    font-size: 8vmax;
  }
  .inputs{
    width: 100%;
  }
  .login .text2{
    text-align: center;
    font-size: 4vmax;
  }
  .website,.forgot_password{
    font-size: 1.8vmax  !important;
    text-align: center;
  }
}

@media screen and (max-width:500px) {
  .login-page{
    height:100%;
  }
  
}


`, "",{"version":3,"sources":["webpack://./src/modules/auth/components/Login.css"],"names":[],"mappings":"AAAA,uFAAuF;;AAEvF;EACE,YAAY;EACZ,WAAW;EACX;;;;;2CAKmD;EACnD,sBAAsB;EACtB,4BAA4B;EAC5B,2BAA2B;AAC7B;AACA;EACE,iBAAiB;EACjB,eAAe;EACf,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,gCAAgC;EAChC,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,0CAA0C;EAC1C,mBAAmB;EACnB,mCAA2B;UAA3B,2BAA2B;EAC3B,oCAAoC;EACpC,6CAA6C;EAC7C,WAAW;EACX,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd;sDACoD;EACpD,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB;sDACoD;EACpD,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd;sDACoD;EACpD,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,6BAA6B;EAC7B,YAAY;EACZ,eAAe;EACf,kBAAkB;;AAEpB;AACA;EACE,yBAAyB;;AAE3B;;AAEA;EACE,aAAa;AACf;;;;AAIA;EACE;IACE,WAAW;EACb;EACA;IACE,kBAAkB;IAClB,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,UAAU;;EAEZ;EACA;IACE,UAAU;IACV,YAAY;;EAEd;EACA;IACE,YAAY;EACd;EACA;IACE,aAAa;EACf;EACA;IACE,uBAAuB;IACvB,mBAAmB;EACrB;EACA;IACE,UAAU;EACZ;EACA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;EACA;IACE,WAAW;EACb;EACA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;EACA;IACE,8BAA8B;IAC9B,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,WAAW;EACb;;AAEF","sourcesContent":["/* #####  Code for Login, LoginComponent, Signup, ForgotPassword, Otpcomponent  ##### */\n\n.login-page {\n  height: 100%;\n  width: 100%;\n  background-image: linear-gradient(\n      to right bottom,\n      #122b4f,\n      rgba(202, 190, 240, 0.082)\n    ),\n    url(\"../../../fonts\\ and\\ images/solarpanel.jpg\");\n  background-size: cover;\n  background-repeat: no-repeat;\n  background-position: center;\n}\n.login-page>:first-child{\n  /* width: 100%; */\n  position: fixed;\n  z-index: 12;\n  padding: 1vmin 1.5vmin; \n}\n\n.login {\n  height: 100%;\n  width: 100%;\n  display: flex;\n  justify-content: space-around;\n  align-items: center;\n  gap: 3vmax;\n}\n\n.login .text-heading {\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  color: white;\n  width: 30%;\n}\n\n.login .login-container {\n  transition:width .3s ease-in-out;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  color: white;\n  width: 30%;\n} \n\n.login-box {\n  padding:  2vmax;\n  background-color: rgba(6, 127, 127, 0.968);\n  border-radius: 10px;\n  backdrop-filter: blur(10px);\n  --webkit-backdrop-filter: blur(10px);\n  box-shadow: 50px 50px 17px rgba(0, 0, 0, 0.6);\n  z-index: 10;\n  border-width: 5px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 1.5vmax;\n}\n\n.login-box>:last-child{\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5vmax;\n}\n\n.inputs {\n  width: 100%;\n  text-align: center;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.inputs>input{\n  height: 3rem;\n  width: 100%;\n}\n\n.buttons {\n  text-align: center;\n}\n\n.login .text-heading .container{\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n  gap: 0.5vmax;\n}\n\n.login .text1 {\n  font-size: 5vmax;\n  color: #ed7d31;\n  font-family: \"Lucida Sans\", \"Lucida Sans Regular\", \"Lucida Grande\",\n    \"Lucida Sans Unicode\", Geneva, Verdana, sans-serif;\n  z-index: 10;\n  font-weight: bolder;\n}\n\n.login .text3 {\n  font-size: 5vmax;\n  color: rgb(231, 229, 221);\n  font-family: \"Lucida Sans\", \"Lucida Sans Regular\", \"Lucida Grande\",\n    \"Lucida Sans Unicode\", Geneva, Verdana, sans-serif;\n  z-index: 10;\n  font-weight: bolder;\n}\n\n.login .text2 {\n  font-size: 1.8vmax;\n  color: #ed7d31;\n  font-family: \"Lucida Sans\", \"Lucida Sans Regular\", \"Lucida Grande\",\n    \"Lucida Sans Unicode\", Geneva, Verdana, sans-serif;\n  z-index: 1;\n  display: block;\n}\n\n.forgot_password{\n  font-size:medium;\n  letter-spacing: 0.1rem;\n  font-weight: 600;\n  color: rgba(5, 45, 45, 0.968);\n  color: white;\n  cursor: pointer;\n  text-align: center;\n\n}\n.forgot_password:hover{\n  color: rgb(237, 241, 245);\n  \n} \n\n.inputs>input{\n  outline: none;\n}\n\n\n\n@media screen and (max-width:950px) {\n  .login-page{\n    height:110%;\n  }\n  .login{\n    padding-top: 4vmax;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: 6vmax;\n\n  }\n  .login .text-heading {\n    width: 70%;\n    height: auto;\n\n  }\n  .login .login-container{\n    height: auto;\n  }\n  .login-box{\n    width: 40vmax;\n  }\n  .login .text-heading .container{\n    justify-content: center;\n    align-items: center;\n  }\n  .login .login-container {\n    width: 50%;\n  }\n  .login .text1,.login .text3{\n    text-align: center;\n    font-size: 8vmax;\n  }\n  .inputs{\n    width: 100%;\n  }\n  .login .text2{\n    text-align: center;\n    font-size: 4vmax;\n  }\n  .website,.forgot_password{\n    font-size: 1.8vmax  !important;\n    text-align: center;\n  }\n}\n\n@media screen and (max-width:500px) {\n  .login-page{\n    height:100%;\n  }\n  \n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
